<script setup lang="ts">
import atsSyncSvg from '@/assets/svg/ats-sync.svg';
import { computed } from 'vue';
import dayjs from 'dayjs';

const props = defineProps({
  mini: {
    type: Boolean,
    default: false,
  },
  lastSynced: {
    type: String,
    default: '',
  },
  remoteJobId: {
    type: String,
    default: '',
  },
});

const isMiniVersion = computed(() => props.mini);
const lastSyncedTs = computed(() => {
  let date = '';
  if (props.lastSynced.trim()) {
    date = dayjs(props.lastSynced).format('MMM DD [at] hh:mmA');
  }

  return date;
});
const hasLastSynced = computed(() => lastSyncedTs.value !== null);
const hasRemoteJobId = computed(() => props.remoteJobId.trim() !== '');
</script>

<template>
  <div
    :class="`flex items-center justify-center rounded bg-primary-600 p-[4px] text-[10px] font-bold leading-[10px] text-primary-1000`"
  >
    <span v-show="!isMiniVersion" v-bind="props" class="font-sans"> ATS SYNC </span>
    <v-tooltip
      v-show="isMiniVersion"
      :disabled="!hasLastSynced && !hasRemoteJobId"
      location="top"
      content-class="bg-shade-880 tooltip-bottom-arrow"
    >
      <template v-slot:activator="{ props }">
        <img
          alt="ATS Sync"
          v-show="isMiniVersion"
          v-bind="props"
          :src="atsSyncSvg"
          class="inline-block"
          :class="{
            'ml-1': !isMiniVersion,
          }"
          height="12"
          width="12"
        />
      </template>

      <!-- Tooltip text -->
      <div class="text-xs">
        <div v-if="hasRemoteJobId">ATS ID: {{ remoteJobId }}</div>
        <div v-if="hasLastSynced">Last Synced: {{ lastSyncedTs }}</div>
      </div>
    </v-tooltip>
  </div>
</template>
